(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Escape values pulled from data-* attributes before building innerHTML.
  // (getAttribute returns the browser-decoded raw text, so it must be re-escaped.)
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function initLightbox(root) {
    var dialog = root.querySelector('.customer-gallery__lightbox');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var img = dialog.querySelector('.customer-gallery__lightbox-img');
    var link = dialog.querySelector('.customer-gallery__lightbox-link');
    var close = dialog.querySelector('.customer-gallery__lightbox-close');
    var review = dialog.querySelector('.customer-gallery__review');

    root.addEventListener('click', function (e) {
      if (root.__cgSuppressTap) { root.__cgSuppressTap = false; return; } // ignore the click that follows a mobile swipe
      var tile = e.target.closest('.customer-gallery__tile');
      if (!tile || !root.contains(tile)) return;
      var full = tile.getAttribute('data-cg-full');
      if (!full) return; // empty/placeholder tile — do nothing
      e.preventDefault();
      var innerImg = tile.querySelector('img');
      img.src = full;
      img.alt = (innerImg && innerImg.alt) || '';
      var href = tile.getAttribute('data-cg-link');
      if (href) {
        link.href = href;
        link.hidden = false;
      } else {
        link.removeAttribute('href');
        link.hidden = true;
      }

      // Optional review card (only when this photo carries review text)
      var rText = tile.getAttribute('data-review-text');
      if (review) {
        if (rText) {
          var rRating = parseInt(tile.getAttribute('data-review-rating') || '0', 10);
          var rHeadline = tile.getAttribute('data-review-headline');
          var rAuthor = tile.getAttribute('data-review-author');
          var rProduct = tile.getAttribute('data-review-product');
          var rLink = tile.getAttribute('data-review-link');
          var verified = tile.getAttribute('data-review-verified') === '1';
          var html = '';
          var top = '';
          if (rRating > 0) {
            var n = Math.min(5, Math.max(0, rRating));
            var stars = '';
            for (var i = 0; i < 5; i++) stars += (i < n ? '★' : '☆');
            top += '<span class="customer-gallery__review-stars" role="img" aria-label="Rated ' + n + ' out of 5">' + stars + '</span>';
          }
          if (verified) top += '<span class="customer-gallery__review-verified">✓ Verified buyer</span>';
          if (top) html += '<div class="customer-gallery__review-top">' + top + '</div>';
          if (rHeadline) html += '<p class="customer-gallery__review-headline">' + esc(rHeadline) + '</p>';
          html += '<p class="customer-gallery__review-text">' + esc(rText) + '</p>';
          var by = '';
          if (rAuthor) by += '<span class="customer-gallery__review-author">' + esc(rAuthor) + '</span>';
          if (rProduct) by += '<span class="customer-gallery__review-product">' + esc(rProduct) + '</span>';
          var footer = '';
          if (by) footer += '<div class="customer-gallery__review-by">' + by + '</div>';
          if (rLink) footer += '<a class="customer-gallery__review-shop" href="' + esc(rLink) + '">Shop this style →</a>';
          if (footer) html += '<div class="customer-gallery__review-footer">' + footer + '</div>';
          review.innerHTML = html;
          review.hidden = false;
          dialog.classList.add('customer-gallery__lightbox--has-review');
        } else {
          review.innerHTML = '';
          review.hidden = true;
          dialog.classList.remove('customer-gallery__lightbox--has-review');
        }
      }

      dialog.showModal();
    });

    if (close) close.addEventListener('click', function () { dialog.close(); });
    // Click outside the inner content (i.e. the dialog backdrop) closes
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }

  // Mobile (≤749px) swipe rail: keep the tap-vs-swipe guard (so a swipe doesn't open the
  // lightbox) and wire the left/right arrow paging buttons. NO auto-advance, NO loop — the rail
  // is a finite native overflow-x scroll. Desktop (≥750px) uses the CSS marquee; the arrows are
  // display:none there and the marquee isn't scrollable, so this is inert on desktop.
  function initMobileCarousel(root) {
    if (!root.classList.contains('customer-gallery--mode-autoscroll')) return; // grid mode has no marquee
    var marquee = root.querySelector('.customer-gallery__marquee');
    if (!marquee) return;

    // Tap-vs-swipe guard: a swipe must NOT open the lightbox (the click handler on root reads the flag).
    var tsx = 0, tsy = 0, tst = 0, moved = false;
    marquee.addEventListener('touchstart', function (e) {
      root.__cgSuppressTap = false; moved = false;
      if (e.touches && e.touches[0]) { tsx = e.touches[0].clientX; tsy = e.touches[0].clientY; tst = Date.now(); }
    }, { passive: true });
    marquee.addEventListener('touchmove', function (e) {
      if (e.touches && e.touches[0] && (Math.abs(e.touches[0].clientX - tsx) > 10 || Math.abs(e.touches[0].clientY - tsy) > 10)) moved = true;
    }, { passive: true });
    marquee.addEventListener('touchend', function () { root.__cgSuppressTap = moved || (Date.now() - tst > 300); }, { passive: true });

    // Arrow paging (mobile only — arrows are display:none ≥750px). One "page" ≈ 85% of the rail.
    var carousel = root.querySelector('.customer-gallery__carousel');
    var prev = carousel && carousel.querySelector('.customer-gallery__arrow--prev');
    var next = carousel && carousel.querySelector('.customer-gallery__arrow--next');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function page(dir) {
      marquee.scrollBy({ left: dir * Math.round(marquee.clientWidth * 0.85), behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    // Lightweight end-state: hide the prev arrow at the start and the next arrow at the end.
    function updateArrows() {
      var max = marquee.scrollWidth - marquee.clientWidth;
      if (prev) prev.disabled = marquee.scrollLeft <= 1;
      if (next) next.disabled = marquee.scrollLeft >= max - 1;
    }
    marquee.addEventListener('scroll', updateArrows, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(updateArrows).observe(marquee);
    else window.addEventListener('resize', updateArrows, { passive: true });
    updateArrows();
  }

  function initSection(root) {
    if (!root || root.__cgInit) return;
    root.__cgInit = true;
    if (root.getAttribute('data-cg-lightbox') === '1') initLightbox(root);
    initMobileCarousel(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.customer-gallery').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patch-shelves"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRail(rail) {
    var track = rail.querySelector('.patch-shelves__track');
    if (!track) return;
    var prev = rail.querySelector('.patch-shelves__arrow--prev');
    var next = rail.querySelector('.patch-shelves__arrow--next');
    var fill = rail.querySelector('.patch-shelves__progress-fill');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > 1;
      rail.classList.toggle('is-scrollable', scrollable);
      // Desktop grid (or any rail that fits): nothing to scroll -> no-op past disabling arrows.
      if (!scrollable) {
        if (prev) prev.disabled = true;
        if (next) next.disabled = true;
        return;
      }
      if (fill) {
        var pct = (track.clientWidth + track.scrollLeft) / track.scrollWidth * 100;
        fill.style.width = Math.min(100, Math.max(0, pct)) + '%';
      }
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });

    function page(dir) {
      if (track.scrollWidth - track.clientWidth <= 1) return; // not scrollable (desktop grid)
      track.scrollBy({ left: dir * Math.max(220, Math.round(track.clientWidth * 0.9)), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }

    rail.querySelectorAll('.patch-shelves__tile').forEach(function (tile) {
      var video = tile.querySelector('.patch-shelves__video');
      if (!video) return;
      function playVideo() {
        if (reduce) return;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      function stopVideo() {
        video.pause();
        try { video.currentTime = 0; } catch (e) {}
      }
      tile.addEventListener('mouseenter', playVideo);
      tile.addEventListener('mouseleave', stopVideo);
      tile.addEventListener('focusin', playVideo);
      tile.addEventListener('focusout', stopVideo);
    });

    update();
  }

  function initSection(root) {
    if (!root || root.__patchShelvesInit) return;
    root.__patchShelvesInit = true;
    root.querySelectorAll('.patch-shelves__rail').forEach(initRail);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.patch-shelves').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when this section is (re)loaded.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
